module.exports = require("@swa-ui/dotcom/src/placements/OffersPlacement/OffersPlacement.module.scss");